<template>
  <div>An error occured</div>
</template>


<script>
export default {
  name: "AsyncError",
};
</script>